var Time = (function () {
	return {
		add: add, // Addition
		tzApi: tzApi, // Change timeZone of API to local time
		tzrApi: tzrApi, // Change timeZone of API to Seoul time
		format: format, // 시간 타입만 변경
		isToday: isToday, // 입력된 날짜가 오늘인지 확인
		fromNow: fromNow, // 지금으로 부터 시간 확인 (알림에서 사용)
		subtract: subtract, // Subtraction
		dayjsObj: dayjsObj,
		localTime: localTime, // 현지 시간
		minToHour: minToHour, // Convert minutes to hour with internationalization
		formatAll: formatAll,
		formatDate: formatDate,
		isYesterday: isYesterday, //입력된 날짜가 내일인지 확인
		isThisWeek: isThisWeek, //입력된 날짜가 이번달인지 확인
		isThisMonth: isThisMonth, //입력된 날짜가 이번주인지 확인
		isSameDate: isSameDate,
		currentTime: currentTime, // 현재 시간 반환
		currentDate: currentDate, // 현재 시간 반환
		roundMinutes: roundMinutes, // 분 단위로 반 올림
		currentTimeZone: currentTimeZone, // 현재 타임존 지역
		commentTzApi: commentTzApi, //댓글 전용 tzApi
		shiftTzAsGMT: shiftTzAsGMT,
		tzrPreferenceTimezoneInArray: tzrPreferenceTimezoneInArray,
		getFormattedTimestamp: getFormattedTimestamp,
		generateGmtToIanaMap: generateGmtToIanaMap,
		getDefaultTimeLocale: getDefaultTimeLocale,
		tzrDtm: tzr,
		tzDtm: tz,
		diff: diff,
		startOf: startOf,
		endOf: endOf,
		toDate: toDate,
		tzByRegion: tzByRegion,
		localizeFormat: localizeFormat,
		getRepeatingDate: getRepeatingDate, // 선택한 날짜와 요일을 넣었을 때 가까운 날짜의 요일 반환
		changeToDate: changeToDate, // 선택한 날짜와 요일을 넣었을 때 가까운 날짜의 요일 반환
		makeJustTimezoneDate: makeJustTimezoneDate, // (date, timezone) => timezone의 date를 그냥 반환
		applyTimeZoneForMadrascheckApis: applyTimeZoneForMadrascheckApis
	};

	// Seoul -> Client Time
	function tz(time, format = reformatByLength(time), startTimezone = getDefaultTimeLocale(), endTimezone = currentTimeZone()) {
		if (!time || time.length < 9 ||!dayjs(time).isValid() || isISODate(time)) return time;
		const convert = dayjs.tz(reformatTime(time), startTimezone || getDefaultTimeLocale());
		let converted = convert.tz(endTimezone || currentTimeZone());
		return converted.format(format);
	}

	// Client Time -> Seoul
	function tzr(time, format = reformatByLength(time), endTimezone = getDefaultTimeLocale()) {
		if (!time || time.length < 9 || !dayjs(time).isValid() || isISODate(time)) return time;
		return dayjs(reformatTime(time)).tz(endTimezone || getDefaultTimeLocale()).format(format)
	}

	function tzApi(json, target = '_DT', exception = "CONVT") {
		if (getDefaultTimeLocale() === currentTimeZone()) return json;
		return tzJson(json, target, exception);
	}

	function tzrApi(json, target = '_DT', exception = "CONVT") {
		if (getDefaultTimeLocale() === currentTimeZone()) return json;
		return tzJson(json, target, exception, true);
	}

	function applyTimeZoneForMadrascheckApis(json, startTimezone, endTimezone) {
		if (startTimezone === endTimezone) return json;
		return tzJson(json, '_DT', 'CONVT', true, startTimezone, endTimezone);
	}

	function shiftTzAsGMT(time, format = reformatByLength(time), startTimeZone, endTimeZone) {
		return dayjs.tz(dayjs(time).format("YYYYMMDDHHmmss"), startTimeZone).tz(endTimeZone).format(format);
	}

	function tzrPreferenceTimezoneInArray(array, startTimezone, endTimezone, target = '_DT', exception = "CONVT") {
		if (startTimezone === endTimezone) return array;
		return tzArray(array, target, exception, false, startTimezone, endTimezone);
	}

	function add(time = currentTime(), addition, unit = 'day', type = reformatByLength(time)) {
		return dayjs(time).add(addition, unit).format(localizeFormat(type))
	}

	function subtract(time = currentTime(), subtraction, unit = 'day', type = reformatByLength(time)) {
		return dayjs(time).subtract(subtraction, unit).format(localizeFormat(type))
	}

	function minToHour(minute) {
		if (minute < 60) return i18next.t(common.minute, {count: minute});
		else return i18next.t(common.hour, {count: Math.floor(minute / 60)});
	}

	function dayjsObj(time) {
		return dayjs(time);
	}

	function isToday(time = currentTime()) {
		return dayjs(time).isToday();
	}

	function isYesterday(time = currentTime()) {
		return dayjs(time).isYesterday();
	}

	function isThisWeek(time = currentTime()) {
		return dayjs(time) >= dayjs().add('-7', 'day') && dayjs(time) <= dayjs().add('+7', 'day')
	}

	function isThisMonth(time = currentTime()) {
		return dayjs().format(localizeFormat('type10')) === dayjs(time).format(localizeFormat('type10'))
	}

	function isSameDate(time, time2) {
		return dayjs(time).format(localizeFormat('type12')) === dayjs(time2).format(localizeFormat('type12'))
	}

	function diff(start, end, type) {
		return dayjs(end).diff(dayjs(start), type, true);
	}

	function startOf(time, unit, type = reformatByLength(time)) {
		return dayjs(time).startOf(unit).format(localizeFormat(type));
	}

	function endOf(time, unit, type = reformatByLength(time)) {
		return dayjs(time).endOf(unit).format(localizeFormat(type));
	}

	function toDate(time) {
		return dayjs(time).toDate();
	}

	function tzJson(json, target = '_DT', exception = 'CONVT', isReverse = false, startTimezone = '', endTimezone = '') {
		const result = {...json};
		for (let key in json) {
			const value = json[key];
			const isValueDttm = key.includes("VALUE") && value && value.length > 7;
			const isVoteDttm = key.includes("CONTENTS") && value && value.length > 15 && /^[0-9]+$/.test(value);
			if ((isValueDttm || key.includes(target) || key.includes("_TIMESTAMP") || isVoteDttm) && !key.includes(exception)) result[key] = isReverse ? tzr(value, reformatByLength(value), endTimezone) : tz(value, reformatByLength(value), startTimezone, endTimezone);
			if (Array.isArray(value)) result[key] = tzArray(value, target, exception, isReverse, startTimezone, endTimezone)
		}
		return result;
	}

	function tzArray(array, value, exception, isReverse, startTimezone = '', endTimezone = '') {
		const result = [];
		array.forEach(json => {
			result.push(tzJson(json, value, exception, isReverse, startTimezone, endTimezone));
		})
		return result;
	}

	function format(time = currentTime(), format = reformatByLength(time)) {
		if (!isValid(time)) return '';
		return dayjs(time).format(localizeFormat(format));
	}

	function formatAll(time = currentTime(), format = reformatByLength(time)) {
		return dayjs(time).format(localizeFormat(format));
	}

	function formatDate(date = currentDate(), format = reformatByLength(date)) {
		if (!isValid(date)) return '';
		return dayjs(date).format(localizeFormat(format));
	}

	function currentTime(format = 'YYYYMMDDHHmmss') {
		return dayjs().format(localizeFormat(format));
	}

	function currentDate(format = 'YYYYMMDD') {
		return dayjs().format(localizeFormat(format));
	}

	function getFormattedTimestamp(format = 'YYYYMMDD') {
		return dayjs().format(format);
	}

	function roundMinutes(minutesRoundBy) {
		const remainder = minutesRoundBy - (dayjs().minute() % minutesRoundBy);
		return dayjs()
			.add(remainder, "minutes")
			.format("HH mm ss");
	}

	function fromNow(time = currentTime()) {
		if (dayjs().diff(time, 'hours') < 21 && dayjs().diff(time, 'days') === 0)
			return dayjs(time).fromNow()

		return format(time, 'type1');
	}

	function currentTimeZone() {
		return dayjs.tz?.guess() || 'Asia/Seoul';
	}

	function localizeFormat(format) {
		const isRawType = !format.includes('type');
		return isRawType ? format : i18next.t(date.format[format]);
	}

	function reformatTime(time = '') {
		if (!time) return '';
		const parsed = dayjs(time);
		if (!parsed.isValid()) return '';
		return parsed.format('YYYYMMDDHHmmss');
	}

	function reformatByLength(time = currentTime()) {
		if (!time) return 'YYYYMMDDHHmmss'
		switch (time.length) {
			case 8:
				return 'YYYYMMDD';
			case 12:
				return 'YYYYMMDDHHmm'
			case 16:
				return 'YYYY-MM-DD'
			default:
				return 'YYYYMMDDHHmmss'
		}
	}

	function isValid(val) {
		if (val === null || val === undefined) return false; // null 또는 undefined 체크
		if (typeof val === 'string' && val.trim() === '') return false; // 빈 문자열 체크
		if (!dayjs(val).isValid()) return false; // dayjs 날짜 유효성 검사

		return true; // 모든 조건을 통과하면 유효한 값
	}

	function localTime(zone = 'Asia/Seoul', format = 'YYYYMMDDHHmmss') {
		return dayjs().tz(zone).format(localizeFormat(format));
	}

	function commentTzApi(str) {
		const dateRegex = /'\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])/g;
		const dtmRegex = /\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01]),\s(0[1-9]|1[0-9]|2[0-4]):(0[1-9]|[0-5][0-9])/g;

		if (!dateRegex.test(str)) return str;
		const dtmArr = str.match(dtmRegex);
		if (dtmArr != null) {
			dtmArr.forEach(function (unformattedDtm) {
				let formattedDtm = formatDate(tz(unformattedDtm.replace(/[-:, \s]/g, '')), 'type25');
				str = str.replace(unformattedDtm, formattedDtm);
			});
		}

		const dateArr = str.match(dateRegex);
		if (dateArr != null) {
			dateArr.forEach(function (unformattedDtm) {
				unformattedDtm = unformattedDtm.replaceAll('\'', '');
				let formattedDtm = formatDate(unformattedDtm.replace(/[-:,\s]/g, ''), 'type24');
				str = str.replace(unformattedDtm, formattedDtm);
			});
		}
		return str;
	}

	function getDefaultTimeLocale() {
		return Often.isGlobal() ? "Atlantic/Reykjavik" : "Asia/Seoul";
	}

	function tzByRegion(time, region = "KR", format = reformatByLength(time)) {
		const TimeLocale = {
			"KR": "Asia/Seoul",
			"GB": "Europe/London",
			"US": "America/New_York",
			"JP": "Asia/Tokyo",
			"VN": "Asia/Ho_Chi_Minh",
			"KH": "Asia/Phnom_Penh",
			"ETC": "Asia/Seoul"
		}

		const isRegionExist = TimeLocale.hasOwnProperty(region);
		if (!time || time.length < 9 || isNaN(time) || !isRegionExist) return time;
		const convert = dayjs.tz(reformatTime(time), TimeLocale[region]);
		const converted = convert.tz(currentTimeZone())
		return converted.format(format);
	}

	function isSummerTimePeriod() {
		const lastThursDayOfApril = dayjs().month(4).startOf('month').day(4).subtract(1, 'week');
		const lastThursDayOfSeptember = dayjs().month(9).startOf('month').day(4).subtract(1, 'week');

		return dayjs().isAfter(lastThursDayOfApril) && dayjs().isBefore(lastThursDayOfSeptember);
	}

	//일렉트론 자체오류 잡기위한 로직.. 24버전 이상으로 업데이트 되면 로직 지워주세요!
	function isElectronDaylightDiff(currentTz) {
		//24버전은 윈도우 7,8 버전을 지원하지 않아서 현 플로우 일렉트론 버전 업데이트는 불가.
		//일렉트론 자체 오류고치기 위해서 강제로 한시간 뺴줌.. https://github.com/electron/electron/issues/37972
		//NOTE. 현재 깃허브 이슈로 올라와있는 것만 추가해줬는데 다른 타임존 필요하다면 추가해주세요~
		const timezonesWithDaylightSavingTime = [
			'America/Mexico_City', 'Africa/Cairo'
		];
		if (timezonesWithDaylightSavingTime.includes(currentTz) && isSummerTimePeriod()) {
			return true;
		}
		return false;
	}

	/**
	 * GMT 오프셋을 IANA 타임존으로 변환하는 매핑 생성
	 * @returns {Object} GMT 오프셋과 IANA 타임존 매핑 객체
	 */
	function generateGmtToIanaMap(offset) {
		const gmtOffsets = {
			"GMT-12:00": "Etc/GMT+12",
			"GMT-11:00": "Pacific/Midway",
			"GMT-10:00": "Pacific/Honolulu",
			"GMT-09:30": "Pacific/Marquesas",
			"GMT-09:00": "America/Anchorage",
			"GMT-08:00": "America/Los_Angeles",
			"GMT-07:00": "America/Denver",
			"GMT-06:00": "America/Chicago",
			"GMT-05:00": "America/New_York",
			"GMT-04:00": "America/Caracas",
			"GMT-03:30": "America/St_Johns",
			"GMT-03:00": "America/Argentina/Buenos_Aires",
			"GMT-02:00": "Atlantic/South_Georgia",
			"GMT-01:00": "Atlantic/Azores",
			"GMT+00:00": "UTC",
			"GMT+01:00": "Europe/London",
			"GMT+02:00": "Europe/Berlin",
			"GMT+03:00": "Europe/Moscow",
			"GMT+03:30": "Asia/Tehran",
			"GMT+04:00": "Asia/Dubai",
			"GMT+04:30": "Asia/Kabul",
			"GMT+05:00": "Asia/Karachi",
			"GMT+05:30": "Asia/Kolkata",
			"GMT+05:45": "Asia/Kathmandu",
			"GMT+06:00": "Asia/Almaty",
			"GMT+06:30": "Asia/Rangoon",
			"GMT+07:00": "Asia/Bangkok",
			"GMT+08:00": "Asia/Singapore",
			"GMT+09:00": "Asia/Seoul",
			"GMT+09:30": "Australia/Darwin",
			"GMT+10:00": "Australia/Sydney",
			"GMT+10:30": "Australia/Lord_Howe",
			"GMT+11:00": "Pacific/Noumea",
			"GMT+12:00": "Pacific/Fiji",
			"GMT+13:00": "Pacific/Tongatapu",
			"GMT+14:00": "Pacific/Kiritimati"
		};

		return gmtOffsets[offset] || getDefaultTimeLocale();
	}

	function getRepeatingDate(startDate, repeatDates, repeatType) {
		const weekdays = {
			'Sunday': 0,
			'Monday': 1,
			'Tuesday': 2,
			'Wednesday': 3,
			'Thursday': 4,
			'Friday': 5,
			'Saturday': 6
		};

		// 날짜를 dayjs 객체로 변환하는 헬퍼 함수
		function dayjsObj(date) {
			return dayjs(date);
		}

		const start = dayjsObj(startDate);
		const year = start.year();

		// YEARLY_DAY 또는 MONTHLY_DAY에 따라 처리
		if (repeatType === 'YEARLY_DAY') {
			const month = monthNameToNumber(repeatDates.month); // 월 이름을 숫자로 변환
			const targetWeekday = weekdays[repeatDates.dow];
			const weekOrder = repeatDates.weekOrder;

			if (month === null || targetWeekday === undefined) {
				throw new Error('Invalid month, day, or weekday');
			}

			const targetDate = calculateTargetDate(month, targetWeekday, weekOrder, year);
			return targetDate.startOf('day').format('YYYYMMDD000000');
		} else if (repeatType === 'MONTHLY_DAY') {
			const targetWeekday = weekdays[repeatDates.dow];
			const weekOrder = repeatDates.weekOrder;

			if (targetWeekday === undefined) {
				throw new Error('Invalid weekday');
			}

			const month = start.month() + 1; // 현재 월 (1-12)
			const targetDate = calculateTargetDate(month, targetWeekday, weekOrder, year);
			return targetDate.startOf('day').format('YYYYMMDDHHmmss');
		} else {
			throw new Error('Invalid repeatType');
		}


		// 공통 날짜 계산
		function calculateTargetDate(month, targetWeekday, weekOrder, year) {
			// 해당 월의 첫 번째 날을 생성
			const firstDayOfMonth = dayjsObj(new Date(year, month - 1, 1));
			const firstDayOfMonthWeekday = firstDayOfMonth.day();

			// 첫 번째 목표 요일을 계산
			let targetDate = firstDayOfMonth;
			if (firstDayOfMonthWeekday <= targetWeekday) {
				targetDate = targetDate.date(1 + targetWeekday - firstDayOfMonthWeekday);
			} else {
				targetDate = targetDate.date(1 + (7 - (firstDayOfMonthWeekday - targetWeekday)));
			}

			// 주순서에 따른 조정
			switch (weekOrder) {
				case 'First':
					break;
				case 'Second':
					targetDate = targetDate.add(1, 'week');
					break;
				case 'Third':
					targetDate = targetDate.add(2, 'week');
					break;
				case 'Fourth':
					targetDate = targetDate.add(3, 'week');
					break;
				case 'Last':
					const lastDayOfMonth = dayjsObj(new Date(year, month, 0));
					const lastDayOfMonthWeekday = lastDayOfMonth.day();
					targetDate = lastDayOfMonth;
					if (lastDayOfMonthWeekday >= targetWeekday) {
						targetDate = targetDate.date(lastDayOfMonth.date() - (lastDayOfMonthWeekday - targetWeekday));
					} else {
						targetDate = targetDate.date(lastDayOfMonth.date() - (7 - (targetWeekday - lastDayOfMonthWeekday)));
					}
					break;
				default:
					throw new Error('Invalid weekOrder value');
			}

			return targetDate;
		}
	}

	function changeToDate(repeatSettingDatas) {
		const startDate = repeatSettingDatas.startDate
		const repeatDates = repeatSettingDatas.repeatDates
		const repeatCycleType = repeatSettingDatas.repeatCycleType
		const repeatDaysOfWeek = repeatSettingDatas.repeatDaysOfWeek
		const start = Time.dayjsObj(startDate); // 시작 날짜를 dayjs 객체로 변환
		const year = dayjs().year(); // 현재 연도 가져오기

		if (repeatCycleType === 'MONTHLY') {
			const day = parseInt(repeatDates.day, 10);

			if (isNaN(day)) {
				throw new Error('Invalid day');
			}

			// 지정된 일로 날짜를 설정하고 시간은 00:00:00으로 설정
			const newDate = start.date(day).startOf('day').format('YYYYMMDD000000');

			return newDate;
		} else if (repeatCycleType === 'YEARLY') {
			const month = monthNameToNumber(repeatDates.month); // 월 이름을 숫자로 변환
			const day = parseInt(repeatDates.day, 10); // 일 값을 정수로 변환

			if (month === null || isNaN(day)) {
				throw new Error('Invalid month or day');
			}

			// 해당 연도와 월, 일로 날짜 생성
			const newDate = dayjs(`${year}-${month}-${day}`, 'YYYY-M-D').format('YYYYMMDD000000');

			return newDate;
		} else if (repeatCycleType === 'WEEKLY') {
			const selectedDate = start;
			const selectedDay = selectedDate.day();

			const dayNameToNumber = {
				'Sunday': 0,
				'Monday': 1,
				'Tuesday': 2,
				'Wednesday': 3,
				'Thursday': 4,
				'Friday': 5,
				'Saturday': 6
			};

			// 반복 요일을 숫자로 변환하고 정렬
			const repeatDayNumbers = repeatDaysOfWeek.map(day => dayNameToNumber[day]).sort((a, b) => a - b);

			// 선택한 요일이 반복 요일에 포함되는지 확인
			if (repeatDayNumbers.includes(selectedDay)) {
				return selectedDate.startOf('day').format('YYYYMMDD000000');
			} else {
				// 가장 가까운 이후의 반복 요일을 찾기
				const nextDayNumber = repeatDayNumbers.find(day => day > selectedDay);

				let newDate;
				if (nextDayNumber !== undefined) {
					// 현재 주 내에서 다음 반복 요일을 찾은 경우
					const diff = nextDayNumber - selectedDay;
					newDate = selectedDate.add(diff, 'day');
				} else {
					// 다음 주로 넘어가야 하는 경우 (가장 첫 번째 반복 요일 선택)
					const firstRepeatDay = repeatDayNumbers[0];
					const diff = 7 - selectedDay + firstRepeatDay;
					newDate = selectedDate.add(diff, 'day');
				}

				return newDate.startOf('day').format('YYYYMMDD000000');
			}
		} else {
			throw new Error('Invalid repeatCycleType');
		}
	}

	// 월 이름을 숫자로 변환하는 함수
	function monthNameToNumber(monthName) {
		const monthArr = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
		// 배열에서 월 이름의 인덱스를 가져와서 1을 더하여 숫자 월로 변환
		const monthIndex = monthArr.indexOf(monthName);
		return monthIndex !== -1 ? monthIndex + 1 : null; // 1부터 시작하는 월 번호를 반환
	}


	function makeJustTimezoneDate(date, timezone) {
		return dayjs(date).tz(timezone);
	}

	function isISODate(input) {
		const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(Z|([+-]\d{2}:\d{2}))?$/;
		return isoRegex.test(input) && dayjs(input).isValid();
	}
})()
